// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.p[data-v-2c85dd67] {\n    line-height: 1;\n}\n.inline-list-item[data-v-2c85dd67]:not(:last-child)::after {\n    content: ', ';\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
